var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.666 6.824v3.333m10-5v3.334m-.833-7.5c2.04 0 3.144.312 3.693.554a.6.6 0 0 1 .216.15c.063.06.178.237.208.32.05.136.05.211.05.361v8.957c0 .758 0 1.136-.114 1.33a.73.73 0 0 1-.443.367c-.213.075-.642-.008-1.5-.172-.6-.116-1.313-.2-2.11-.2-2.5 0-5 1.666-8.333 1.666-2.04 0-3.145-.312-3.694-.554a.6.6 0 0 1-.215-.15 1.2 1.2 0 0 1-.208-.32c-.05-.137-.05-.212-.05-.362V3.981c0-.757 0-1.136.114-1.33a.73.73 0 0 1 .443-.366c.212-.075.641.007 1.5.172.6.116 1.313.2 2.11.2 2.5 0 5-1.666 8.333-1.666M11.75 7.657a2.083 2.083 0 1 1-4.167 0 2.083 2.083 0 0 1 4.167 0"
  })));
};
export default SvgMoney;